export const SET_BRANCHES = 'set_branches'
export const RESET_BRANCHES = 'reset_branches'
